module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_250_500.5497ba2d.png";